import React from "react";
import { Images } from "./images";
import Image from "gatsby-image";
import Opengraph from "../../../../assets/images/cases/bruczek/og.png"
import BannerIcon from "../../../../assets/icons/cases/banner-icon.svg";
import Icon1 from "../../../../assets/icons/cases/bruczek/icon-1.svg";
import Icon2 from "../../../../assets/icons/cases/bruczek/icon-2.svg";
import Icon3 from "../../../../assets/icons/cases/bruczek/icon-3.svg";
import Icon4 from "../../../../assets/icons/cases/bruczek/icon-4.svg";
import Icon5 from "../../../../assets/icons/cases/bruczek/icon-5.svg";
import Icon6 from "../../../../assets/icons/cases/bruczek/icon-6.svg";
import Icon7 from "../../../../assets/icons/cases/bruczek/icon-7.svg";
import Icon8 from "../../../../assets/icons/cases/bruczek/icon-8.svg";
import Icon9 from "../../../../assets/icons/cases/bruczek/icon-9.svg";
import Icon10 from "../../../../assets/icons/cases/bruczek/icon-10.svg";

import Icon11 from "../../../../assets/icons/cases/bruczek/icon-11.svg";
import Icon12 from "../../../../assets/icons/cases/bruczek/icon-12.svg";
import Icon13 from "../../../../assets/icons/cases/bruczek/icon-13.svg";

export const BruczekData = () => {
  const images = Images();
  return {
    color: "#fff",
    title: "Bruczek",
    seo: "Działania odpowiadające na potrzeby marki",
    description: 'Działania odpowiadające na potrzeby marki',
    slug: "bruczek",
    opengraph: Opengraph,
    hero: {
      title: "Bruczek",
      color: "#fff",
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.hero.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.detail.childImageSharp.fluid}
        />
      ),
    },
    what_we_did: {
      title: "Utworzenie sklepu internetowego promującego buty",
      text:
        <>
          Marka, która na co dzień pomaga innym, tym razem potrzebowała pomocy agencji interaktywnej! Dla Fiz-Osteo wykonaliśmy nową stronę internetową. Z naszą pomocą marka także przeszła rebranding, którego efektem było nowe logo. Ponadto zajęliśmy się social media marketingiem - prowadziliśmy profile społecznościowe na Facebooku i Instagramie. Zaprojektowaliśmy grafiki i szablony, które wykorzystywaliśmy w tworzeniu kreatywnego i wartościowego contentu w internecie.
        </>,
      technologies: [
        "Strona WWW",
        "UX Workshops",
        "Rebranding",
        "Social Media",
      ],
      list: [
        "Przeprowadziliśmy rebranding marki",
        "Zaprojektowaliśmy nowe logo",
        "Wykonaliśmy grafiki i szablony",
        "Zaprojektowaliśmy i zakodowaliśmy stronę internetową",
        "Opracowaliśmy schemat działań social media",
      ],
    },
    list: {
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_bg.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_detail.childImageSharp.fluid}
        />
      ),
    },
    contact_banners: {
      first: {
        icon: BannerIcon,
        title: 'Wzmocnij pozycję swojego sklepu internetowego',
        text: <>
          Nie masz czasu, żeby przeczytać więcej? Napisz&nbsp;do&nbsp;nas&nbsp;->
          <br/>
          Jeżeli potrzebujesz więcej informacji, czytaj dalej.
        </>,
        button: 'Napisz do nas!',
      }
    },
    headers: {
      first: "",
      second: "",
    },
    icons: {
      first: {
        items: [
          {
            icon: Icon11,
            text: ' Pierwsza w POLSCE darmowa aplikacja, która zrzesza Brukarzy z całego regionu: '
          },
          {
            icon: Icon12,
            text: 'Stworzyliśmy narzędzie do komunikacji z brukarzami'
          },
          {
            icon: Icon13,
            text: 'Lepsza organizacja pracy brukarzy. Wszystko w jednym miejscu'
          },
        ],
      },
      second: {
        title: "Co udało się wykonać?",
        items: [
          {
            icon: Icon1,
            text: 'Audyt'
          },
          {
            icon: Icon2,
            text: 'Strategia marketingowa'
          },
          {
            icon: Icon3,
            text: 'Warsztaty biznesowe w celu opracowania narzędzi online'
          },
          {
            icon: Icon4,
            text: 'Moodboard'
          },
          {
            icon: Icon5,
            text: 'Makiety'
          },
          {
            icon: Icon6,
            text: 'Prototyp'
          },
          {
            icon: Icon7,
            text: 'Aplikacja PWA'
          },
          {
            icon: Icon8,
            text: 'CRM'
          },
          {
            icon: Icon9,
            text: 'Strona www  / Landing page'
          },
          {
            icon: Icon10,
            text: 'DTP'
          },
        ],
      }
    },
    text_boxes: {
      first: {
        title: "Opracowanie i wdrożenie",
        text: <>
          Aplikacja PWA : Pierwsza w POLSCE darmowa aplikacja, która zrzesza Brukarzy z całego regionu:
          <br/>
          Wsparcie i poprawa zarządzania procesami w firmie
          <br/>
          Narzędzie do komunikacji z brukarzami
          <br/>
          Narzędzie do pozyskania nowych klientów
          <br/>
          Organizacja pracy brukarzy (wszystko w jednym miejscu)
          <br/>
          Dostęp do zaangażowanej społeczności brukarzy
          <br/>
          Zbieranie punktów i wymienianie ich na nagrody (specjalistyczne wyposażenie dla brukarzy).
          <br/> <br/>
          Na wzór programów lojalnościowych, do długotrwałych działań, które mają na celu zbudowanie i wzmocnienie relacji z klientami i nagrodzenie za zakup usług i produktów o dużym znaczeniu sprzedażowym. Rozwiązanie umożliwi zdobywanie lojalnych klientów.
        </>,
      },
      second: {
        title: "Stworzenie dedykowanego CRM",
        text: <>
          który umożliwi zarządzanie relacjami z aktualnymi i potencjalnymi klientami. Rozwiązanie zawierać będzie zbiór zadań, procedur i narzędzi, które są niezbędne w kontakcie z kontrahentem. Aplikacja umożliwi kontrolę nad obsługą procesów sprzedażowych, a także możliwość analizy wybranych wartości.
          <br/> <br/>

          Dzięki czemu poprawiona zostanie efektywności wszystkich wewnętrznych działań w przedsiębiorstwie
        </>,
      },
      third: {
        title: "Strona WWW",
        text: <>
          Opracowanie projektu nowego layoutu oraz funkcjonalności strony www mające na celu efektowną prezentację oferty oraz ułatwienie nawigacji w obrębie serwisu. Wszystkie elementy witryny są edytowalne z poziomu panelu CMS, zaprojektowanego tak, by maksymalnie usprawnić zarządzanie treścią.
        </>
      },
      fourth: {
        title: 'Zasięg',
        text: <>
          Województwo Podkarpackie
          <br/>
          Grupa docelowa kampanii
          <br/>
          Brukarze
          <br/>
          Projektanci
          <br/>
          Klienci indywidualni
          <br/>
          Pracownicy Centrum Bruku
          <br/>
          Partnerzy biznesowi
          <br/>
          Czas działań: 12 miesięcy
        </>
      },
    },
    content_images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_2.childImageSharp.fluid}
        />
      ),
    },
    full_images: {
      first: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.full_1.childImageSharp.fluid}
          />
        )
      },
      second: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.full_2.childImageSharp.fluid}
          />
        )
      }
    }
  };
};
